import { Trans, useTranslation } from 'react-i18next';
import { Link } from '@hotjar/hotsauce';
import { EmptyState } from '@hotjar/webapp/components/EmptyState';
import { SUPPORT_URLS } from '@hotjar/webapp/constants/support';
import { useTrack } from '@hotjar/webapp/hooks/useTrack';
import { NoButtonSubtitle, SubtitleContainer, Wrapper } from './styles';

export const NoDataForDateRangeEmptyState = (): JSX.Element => {
  const { t } = useTranslation();
  const { click } = useTrack();

  const onLearnMoreClick = () =>
    click('learn_more_link_KB_article_8917152574743', 'recordings-clicked-element-no-matches', {});

  return (
    <Wrapper>
      <EmptyState
        icon="tray_empty"
        iconColor="text_default"
        title={t('common:recordings.list.empty-v3.title')}
        subtitle={
          <SubtitleContainer>
            {t('common:recordings.list.empty-v3.suggestion-1')}
            <br />
            {t('common:recordings.list.empty-v3.suggestion-2')}
          </SubtitleContainer>
        }
      />
      <NoButtonSubtitle>
        <Trans i18nKey="common:recordings.list.empty-v3.suggestion-read-more">
          More on the{' '}
          <Link
            as="a"
            kind="inline"
            onClick={onLearnMoreClick}
            isExternal
            href={SUPPORT_URLS.clickedElementFilter}
          >
            clicked element filter
          </Link>
        </Trans>
      </NoButtonSubtitle>
    </Wrapper>
  );
};
